import { createJSONRequest } from '@/api/create-request'

export interface TrialCheckoutData {
  user: {
    first_name: string | null
    last_name: string | null
    email: string
  }
  organisation: {
    name: string | null
    address_line1: string | null
    address_city: string | null
    address_postal_code: string | null
    address_country: string | null
    vat_number: string | null
  }
  trial_available: boolean
}

export interface ClaimTrialPayload {
  first_name: string
  last_name: string
  company_name: string
  address_line1: string
  address_city: string
  address_postal_code: string
  address_country: string
  vat_number?: string | null
}

export interface ClaimTrialResponse {
  checkout_url: string
}

export const getCheckoutData = (): Promise<TrialCheckoutData> =>
  createJSONRequest({
    url: '/api/transition-reports/trial/checkout-data',
    method: 'GET',
  })

export const claimTrial = (data: ClaimTrialPayload): Promise<ClaimTrialResponse> =>
  createJSONRequest({
    url: '/api/transition-reports/trial/claim',
    method: 'POST',
    data,
  })
